import React from "react";
import { requestNotificationPermission } from "../../../utils/notifications";

export const ReminderPicker = ({
    reminderType,
    setReminderType,
    reminderDate,
    setReminderDate,
    showReminder,
    setShowReminder,
    reminderRef
}) => {
    const isConfigured = reminderType !== "none";

    const getReminderLabel = () => {
        if (reminderType === "at_time") return "A la hora";
        if (reminderType === "custom") return reminderDate ? "Aviso prog." : "Personalizado";
        return "Recordatorio";
    };

    return (
        <div className="relative" ref={reminderRef}>
            <button
                type="button"
                onClick={() => setShowReminder(!showReminder)}
                className={`px-2.5 py-1.5 rounded-lg border text-xs font-medium flex items-center space-x-1.5 transition-all duration-200
                    ${isConfigured 
                        ? "bg-purple-50 border-purple-300 text-purple-800 font-semibold shadow-sm" 
                        : showReminder 
                            ? "bg-purple-50/50 border-purple-200 text-purple-700" 
                            : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
                    }`}
            >
                <i className={`${isConfigured ? "fas fa-bell text-purple-600" : "far fa-bell text-gray-400"} text-sm transition-colors`}></i>
                <span>{getReminderLabel()}</span>
                {isConfigured && (
                    <i className="fas fa-check text-[9px] bg-purple-600 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center ml-0.5 animate-fadeIn"></i>
                )}
            </button>

            {showReminder && (
                <div className="absolute left-0 top-full mt-2 p-3 bg-white border border-gray-200 rounded-lg shadow-xl z-50 w-56 space-y-2 animate-fadeIn">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Aviso</label>
                    <select
                        value={reminderType}
                        onChange={async (e) => {
                            const value = e.target.value;
                            setReminderType(value);
                            if (value !== "none") {
                                await requestNotificationPermission();
                            }
                        }}
                        className="w-full p-1.5 border border-gray-200 rounded text-xs text-gray-700 focus:outline-none bg-white"
                    >
                        <option value="none">Sin recordatorio</option>
                        <option value="at_time">A la hora de la tarea</option>
                        <option value="custom">Fecha y hora personalizada</option>
                    </select>
                    {reminderType === "custom" && (
                        <input
                            type="datetime-local"
                            value={reminderDate}
                            onChange={(e) => setReminderDate(e.target.value)}
                            className="w-full p-1.5 border border-gray-200 rounded text-xs text-gray-700 focus:outline-none"
                        />
                    )}
                </div>
            )}
        </div>
    );
};
